{
  "actions": "Radnje",
  "actionsAvailable": "Dostupne radnje.",
  "clearSelection": "Poništi odabir",
  "selected": "Odabrano: { count }",
  "selectedAll": "Sve je odabrano"
}
